import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {Button} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';
import {FieldArray} from 'formik';
import ReceiptItem from '../ReceiptItem';
import PopupFailedUploadedAgents from "../PopupFailedAgents";
import * as actions from "../../../../components/PopupAddReceipt/_redux/popupAddReceiptActions";
import {paymentTypeOptions} from '../../../../../_common/constants/options';


export default function UnitGrid({
                                   values,
                                   valuesSet,
                                   findAgentAction,
                                   setFieldValue,
                                   getInvoicesList,
                                   setPopupRowIndex,
                                 }) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showFailedAgents, setShowFailedAgents] = useState(false);

  const headerCellClassName = 'header-cell w-135px px-1';
  const headerClassName = `d-flex justify-content-between custom-brand-color header  pr-2
  ${(values.multipleAgents || values.lines.length > 8) ? 'pr-8' : ''}`;
  const commonButtonClassName = 'custom-send-button col-2 mx-3';

  const columnAgent = intl.formatMessage({
    id: 'receipts-popup-grid-column-agent',
    defaultMessage: 'Agent',
  });
  const columnDetails = intl.formatMessage({
    id: 'receipts-popup-grid-column-details',
    defaultMessage: 'Details',
  });
  const columnPaymentType = intl.formatMessage({
    id: 'receipts-popup-grid-column-payment-type',
    defaultMessage: 'Payment type',
  });
  const columnDate = intl.formatMessage({
    id: 'receipts-popup-grid-column-date',
    defaultMessage: 'Date',
  });
  const columnCheckNumber = intl.formatMessage({
    id: 'receipts-popup-grid-column-check-number',
    defaultMessage: 'Check number',
  });
  const columnBankCode = intl.formatMessage({
    id: 'receipts-popup-grid-column-bank-code',
    defaultMessage: 'Bank code',
  });
  const columnBranchNumber = intl.formatMessage({
    id: 'receipts-popup-grid-column-branch-number',
    defaultMessage: 'Branch number',
  });
  const columnAccountNumber = intl.formatMessage({
    id: 'receipts-popup-grid-column-account-number',
    defaultMessage: 'Account number',
  });
  const columnAmount = intl.formatMessage({
    id: 'receipts-popup-grid-column-amount',
    defaultMessage: 'Amount',
  });
  const buttonLabelImport = intl.formatMessage({
    id: 'receipts-popup-invoices-button-importExcel',
    defaultMessage: 'Import from excel',
  });
  const buttonLabelAddLine = intl.formatMessage({
    id: 'receipts-popup-button-add-line',
    defaultMessage: 'Add line',
  });

  const {failedUploadedAgents} = useSelector((state) => ({
    failedUploadedAgents: state['popupAddReceipt'].failedUploadedAgents
  }), shallowEqual);

  const onChange = async (e) => {
    let file = e.target.files[0];
    if (file) {
      const gridData = await dispatch(actions.uploadMultiAgentsFile(file));

      const mappedDataParsed = gridData.parsed.map(async item => {
        const {paymentType, agentID, ...rest} = item;

        const agentData = await dispatch(actions.findCustomerAgent(agentID, true));

        const filteredPaymentType = paymentTypeOptions.filter(item => item.value === paymentType);

        return {
          agentID: agentData.length > 0 ? agentData[0] : null,
          paymentType: filteredPaymentType.length > 0 ? filteredPaymentType[0] : null,
          ...rest
        }
      });

      Promise.all(mappedDataParsed)
        .then((value) => {
          let changedLinesValue = [...values.lines, ...value];
          setFieldValue('lines', changedLinesValue);
      })

      if (gridData.failed.length > 0) {
        setShowFailedAgents(true);
      }
    }
  };

  return (
    <div className="popup-add-receipt-grid">
      <div className={headerClassName}>
        {values.multipleAgents && (
          <div className={headerCellClassName}>
            {columnAgent}
          </div>
        )}
        <div className={headerCellClassName}>
          {columnDetails}
        </div>
        <div className={headerCellClassName}>
          {columnPaymentType}
        </div>
        {values.receiptType !== 'new' && (
          <div className={headerCellClassName}>
            {columnDate}
          </div>
        )}
        <div className={headerCellClassName}>
          {columnCheckNumber}
        </div>
        <div className={headerCellClassName}>
          {columnBankCode}
        </div>
        <div className={headerCellClassName}>
          {columnBranchNumber}
        </div>
        <div className={headerCellClassName}>
          {columnAccountNumber}
        </div>
        <div className={headerCellClassName}>
          {columnAmount}
        </div>
        {values.multipleAgents &&
        <div className={'w-35px'}/>
        }
        <div className={'w-30px'}/>
      </div>
      <FieldArray name={'lines'}>
        {({remove, push}) => {
          return (
            <>
              <div className="w-100 py-1 add-receipt-grid-body">
                {(values.lines.length > 0) && values.lines.map((sets, index) => (
                  <div key={index} className="d-flex align-items-center py-1">
                    <ReceiptItem
                      agent={`lines.${index}.agentID`}
                      description={`lines.${index}.description`}
                      paymentType={`lines.${index}.paymentType`}
                      dueDate={`lines.${index}.dueDate`}
                      checkNumber={`lines.${index}.checkNumber`}
                      bankCode={`lines.${index}.bankCode`}
                      branchNumber={`lines.${index}.branchNumber`}
                      accountNumber={`lines.${index}.accountNumber`}
                      amount={`lines.${index}.amount`}
                      invoices={`lines.${index}.invoices`}
                      values={values}
                      findAgentAction={findAgentAction}
                      setFieldValue={setFieldValue}
                      getInvoicesList={getInvoicesList}
                      setPopupRowIndex={setPopupRowIndex}
                      index={index}
                      onRemove={() => {
                        remove(index);
                      }}
                    />
                  </div>
                ))
                }
              </div>
              <div className={'d-flex justify-content-center mt-6 mx-auto'}>
                <Button
                  className={commonButtonClassName}
                  onClick={() => {
                    push(valuesSet);
                  }}
                >
                  <img
                    src={toAbsoluteUrl('/media/svg/Plus_square_white.svg')}
                    alt="add-row"
                    className="mr-2 w-20px"
                  />
                  {buttonLabelAddLine}
                </Button>
                {values.multipleAgents && (
                  <Button
                    className={`${commonButtonClassName} d-flex p-0`}
                    onClick={() => {
                    }}
                  >
                    <label
                      className={'w-100 h-100 mb-0 cursor-pointer d-flex justify-content-center align-items-center'}
                    >
                      <img
                        src={toAbsoluteUrl('/media/svg/Uploaded-file_white.svg')}
                        alt="upload-file"
                        className={'mr-2'}
                      />
                      {buttonLabelImport}
                      <input
                        type="file"
                        className="d-none"
                        onChange={onChange}
                        onClick={(e) => {
                          e.target.value = null;
                        }}
                      />
                    </label>
                  </Button>
                )}
              </div>
            </>
          );
        }}
      </FieldArray>
      <PopupFailedUploadedAgents
        showPopup={showFailedAgents}
        handleClosePopup={() => setShowFailedAgents(false)}
        data={failedUploadedAgents}
      />
    </div>
  );
}
